import { render, staticRenderFns } from "./JobTechnicianMessage.vue?vue&type=template&id=3adfe2cb&"
import script from "./JobTechnicianMessage.vue?vue&type=script&lang=js&"
export * from "./JobTechnicianMessage.vue?vue&type=script&lang=js&"
import style0 from "./JobTechnicianMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports